import { render, staticRenderFns } from "./GenerateTkButtons.vue?vue&type=template&id=796e43c8&scoped=true&"
import script from "./GenerateTkButtons.vue?vue&type=script&lang=ts&"
export * from "./GenerateTkButtons.vue?vue&type=script&lang=ts&"
import style0 from "./GenerateTkButtons.vue?vue&type=style&index=0&id=796e43c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796e43c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
